import React, { useState, useEffect, memo } from 'react';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar = memo(() => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          setScrolled(window.scrollY > 50);
          ticking = false;
        });
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container container">
        <a href="#hero" className="navbar__logo">
          <span className="navbar__logo-icon">◆</span>
          <span className="navbar__logo-text">Site Crafts</span>
        </a>

        <div className="navbar__links">
          <a href="#process">Process</a>
          <a href="#packages">Packages</a>
          <a href="#faq">FAQ</a>
          <a href="#get-started">Get Started</a>
        </div>

        <a href="#packages" className="navbar__cta btn-primary">
          View Pricing
        </a>

        <button
          className="navbar__menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {menuOpen && (
          <div className="navbar__mobile-menu">
            <a href="#process" onClick={() => setMenuOpen(false)}>Process</a>
            <a href="#packages" onClick={() => setMenuOpen(false)}>Packages</a>
            <a href="#faq" onClick={() => setMenuOpen(false)}>FAQ</a>
            <a href="#get-started" onClick={() => setMenuOpen(false)}>Get Started</a>
          </div>
        )}
      </div>
    </nav>
  );
});

export default Navbar;
